import { Box, Skeleton } from '@machobear/design-system'
import { VerificationCompleted } from './verification-completed'
import { PendingVerificationByMail } from './pending-verification-by-mail'
import { PendingVerificationByDocument } from './pending-verification-by-document'
import { NoVerification } from './no-verification'
import { useListingData } from '../../../context/listing-data'

export const VerifyListing = () => {
  const { listingVerificationRequested, listingVerificationByMail, listingVerified, loading } =
    useListingData()

  if (loading)
    return (
      <Box paddingY="xxsmall">
        <Skeleton.Shape width="100%" height="100px" />
      </Box>
    )

  if (listingVerified) {
    return <VerificationCompleted />
  }

  if (listingVerificationByMail) {
    return <PendingVerificationByMail />
  }

  if (listingVerificationRequested) {
    return <PendingVerificationByDocument />
  }

  return <NoVerification />
}
